(function () {
  const LOG_PREFIX = '[cart-quantity]';
  let isUpdating = false;
  let pendingUpdate = null;

  console.log(LOG_PREFIX, 'Shopify section rendering updater loaded');

  document.addEventListener('click', function (event) {
    const removeButton = event.target.closest('[data-cart-remove-line]');

    if (removeButton && removeButton.closest('#main-cart-items')) {
      const cartItem = removeButton.closest('.cart-item');
      const input = cartItem && cartItem.querySelector('[data-cart-qty-input]');

      if (!input) return;

      event.preventDefault();

      const line = parseInt(input.dataset.index, 10);
      const updates = getCartUpdates();
      updates[line - 1] = 0;

      input.value = 0;
      updateLinePrice(input, 0);
      changeQuantity(line, 0, input.dataset.cartKey, updates);
      cartItem.remove();
      updateCartTotal();
      updateCartBubble(getCurrentCartItemCount());
      return;
    }

    const btn = event.target.closest('.quantity__button');

    if (!btn || !btn.closest('#main-cart-items')) return;

    const wrapper = btn.closest('[data-cart-qty-control]');
    const input = wrapper && wrapper.querySelector('[data-cart-qty-input]');

    console.log('WRAPPER:', wrapper);
    console.log('INPUT:', input);

    if (!wrapper || !input) {
      console.warn(LOG_PREFIX, 'quantity wrapper or input not found');
      return;
    }

    event.preventDefault();

    const line = parseInt(input.dataset.index, 10);
    let quantity = parseInt(input.value, 10) || 0;

    if (btn.name === 'plus') quantity++;
    if (btn.name === 'minus') quantity--;
    if (quantity < 0) quantity = 0;
    input.value = quantity;
    updateLinePrice(input, quantity);
    updateCartBubble(getCurrentCartItemCount());

    console.log('LINE:', input.dataset.index);
    console.log('VALUE:', quantity);

    changeQuantity(line, quantity, input.dataset.cartKey);
  });

  document.addEventListener('change', function (event) {
    const input = event.target.closest('[data-cart-qty-input]');

    if (!input || !input.closest('#main-cart-items')) return;

    const wrapper = input.closest('[data-cart-qty-control]');
    const line = parseInt(input.dataset.index, 10);
    let quantity = parseInt(input.value, 10) || 0;

    if (quantity < 0) quantity = 0;

    console.log('WRAPPER:', wrapper);
    console.log('INPUT:', input);
    console.log('LINE:', input.dataset.index);
    console.log('VALUE:', quantity);

    changeQuantity(line, quantity, input.dataset.cartKey);
  });

  document.addEventListener('submit', async function (event) {
    const form = event.target.closest('#cart');
    const submitter = event.submitter;

    if (!form || !submitter || submitter.name !== 'checkout') return;

    event.preventDefault();

    await syncCartQuantities();
    window.location.href = '/checkout';
  });

  async function changeQuantity(line, quantity, key, updatesOverride) {
    if (!Number.isInteger(line) || line < 1) {
      console.warn(LOG_PREFIX, 'invalid line index', line);
      return;
    }

    if (isUpdating) {
      console.log(LOG_PREFIX, 'ignored update while request is running');
      pendingUpdate = {
        line: line,
        quantity: quantity,
        key: key,
        updates: updatesOverride
      };
      return;
    }

    isUpdating = true;
    clearCartError();

    console.log(LOG_PREFIX, 'POST /cart/update.js', {
      line: line,
      quantity: quantity
    });

    try {
      const changeResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: updatesOverride || getCartUpdates()
        })
      });

      console.log(LOG_PREFIX, 'change status:', changeResponse.status);

      if (!changeResponse.ok) {
        throw new Error('Cart line update failed.');
      }

      const cart = await changeResponse.json();
      updateCartBubble(cart.item_count);
      await renderCartSections();
    } catch (error) {
      console.error(LOG_PREFIX, error);
      showCartError('Cart update failed. Please try again.');
    } finally {
      isUpdating = false;
      if (pendingUpdate) {
        const nextUpdate = pendingUpdate;
        pendingUpdate = null;
        changeQuantity(nextUpdate.line, nextUpdate.quantity, nextUpdate.key, nextUpdate.updates);
      }
    }
  }

  async function syncCartQuantities() {
    const updates = getCartUpdates();

    if (!updates.length) return;

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates: updates
      })
    });

    if (!response.ok) {
      throw new Error('Cart sync before checkout failed.');
    }

    const cart = await response.json();
    updateCartBubble(cart.item_count);
  }

  function getCartUpdates() {
    return Array.from(document.querySelectorAll('[data-cart-qty-input]'))
      .sort(function (a, b) {
        return (parseInt(a.dataset.index, 10) || 0) - (parseInt(b.dataset.index, 10) || 0);
      })
      .map(function (input) {
        return parseInt(input.value, 10) || 0;
      });
  }

  async function renderCartSections() {
    const sectionUrl = `${window.routes.cart_url}?sections=cart-items,cart-footer,cart-icon-bubble`;

    console.log(LOG_PREFIX, 'GET sections:', sectionUrl);

    const response = await fetch(sectionUrl);

    if (!response.ok) {
      throw new Error('Cart section render failed.');
    }

    const sections = await response.json();

    replaceSectionHtml('cart-items', sections['cart-items'], 'cart-items');
    replaceSectionHtml('cart-footer', sections['cart-footer'], '[data-cart-footer]');
    replaceCartIconBubble(sections['cart-icon-bubble']);

    console.log(LOG_PREFIX, 'cart sections rendered');
  }

  function replaceSectionHtml(sectionId, html, selector) {
    if (!html) return;

    const currentElement = document.querySelector(selector);
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const nextElement = parsedHtml.querySelector(selector);

    if (!currentElement || !nextElement) {
      console.warn(LOG_PREFIX, 'section target not found', sectionId);
      return;
    }

    currentElement.innerHTML = nextElement.innerHTML;
  }

  function updateLinePrice(input, quantity) {
    const cartItem = input.closest('.cart-item');
    const unitPrice = parseInt(input.dataset.unitPrice, 10);

    if (!cartItem || !Number.isInteger(unitPrice)) return;

    const linePrice = formatMoney(unitPrice * quantity);

    cartItem.querySelectorAll('.cart-item__totals [data-cart-line-price]').forEach(function (priceElement) {
      priceElement.textContent = linePrice;
    });

    updateCartTotal();
  }

  function updateCartTotal() {
    let total = 0;

    document.querySelectorAll('[data-cart-qty-input]').forEach(function (input) {
      const unitPrice = parseInt(input.dataset.unitPrice, 10);
      const quantity = parseInt(input.value, 10) || 0;

      if (Number.isInteger(unitPrice)) {
        total += unitPrice * quantity;
      }
    });

    document.querySelectorAll('[data-cart-total]').forEach(function (totalElement) {
      totalElement.textContent = formatMoney(total);
    });
  }

  function getCurrentCartItemCount() {
    let itemCount = 0;

    document.querySelectorAll('[data-cart-qty-input]').forEach(function (input) {
      itemCount += parseInt(input.value, 10) || 0;
    });

    return itemCount;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.DT_THEME && window.DT_THEME.moneyFormat);
    }

    return 'Rs. ' + (cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function updateCartBubble(itemCount) {
    const cartIcon = document.getElementById('cart-icon-bubble');

    if (!cartIcon) return;

    let bubble = cartIcon.querySelector('.cart-count-bubble');

    if (itemCount <= 0) {
      if (bubble) bubble.remove();
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      cartIcon.appendChild(bubble);
    }

    bubble.innerHTML = itemCount < 100
      ? '<span aria-hidden="true">' + itemCount + '</span><span class="visually-hidden">' + itemCount + ' items</span>'
      : '<span class="visually-hidden">' + itemCount + ' items</span>';
  }

  function replaceCartIconBubble(html) {
    if (!html) return;

    const cartIcon = document.getElementById('cart-icon-bubble');
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const sectionElement = parsedHtml.querySelector('.shopify-section');

    if (!cartIcon || !sectionElement) return;

    cartIcon.innerHTML = sectionElement.innerHTML;
  }

  function clearCartError() {
    const errors = document.getElementById('cart-errors');

    if (errors) errors.textContent = '';
  }

  function showCartError(message) {
    const errors = document.getElementById('cart-errors');

    if (errors) errors.textContent = message;
  }
})();
